import { styled, Typography } from "@mui/material";
import React from "react";
import {
  fontFamily,
  fontSize,
  fontWeight,
  gaps,
  margin,
} from "theme/defaultStyle";
import CustomTooltip from "controls/global/custom-tooltip";
import AgencyField from "./AgencyField";
import AgencyLocationField from "./AgencyLocationField";
import AgencyStateField from "./AgencyStateField";
import LevelField from "./LevelField";
import StyledInfoIcon from "theme/icons/StyledInfoIcon";
import { useSignatureDefaultDialogProvider } from "pages/signatures/providers/signature-defaults/SignatureDefaultDialogProvider";
import MultiSelectAgencyLocationField from "./MultiselectAgencyLocationField";

const SIGNATURE_ACCESS_TOOLTIP = "Select ‘User Only’ to make this signature visible only to you, or ‘Agency‑Wide’ to make it available to all users with access to the selected agencies.";

const FieldTitle = styled(Typography)({
  fontFamily: "Inter",
  fontSize: fontSize.medium,
  fontWeight: fontWeight.normal1,
  marginTop: margin.xlarge1,
});

const StyledSignatureAccessContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: `${gaps.large1}`,
  marginTop: margin.xlarge1,
});

const StyledToolTip = styled(CustomTooltip)({
  "& .MuiSvgIcon-root": {
    alignItems: "center",
    display: "flex",
    height: "100%",
  },
});

const DefaultInfoWrapper = styled("div")({});

const signatureToolTipStyle = {
  fontSize: fontSize.small,
  fontFamily: fontFamily.inter,
  fontWeight: fontWeight.normal1,
}

const StyledAddDefaultSignatureNoteText = styled(Typography)({
  margin: `${margin.xlarge1} ${margin.zero} ${margin.small1} ${margin.zero}`,
  fontSize: fontSize.medium,
  fontFamily: fontFamily.inter,
  fontWeight: fontWeight.normal1,
});

const ADD_DEFAULT_SIGNATURE_NOTE = "Note, separate default signatures will be created for each selected Agency Location. Once saved, each default signature must be edited individually.";

const DefaultInfo = () => {
  const {
    mode
  } = useSignatureDefaultDialogProvider();
  return (
    <DefaultInfoWrapper>
      <FieldTitle>
        Choose where you&apos;d like the Signature to default
      </FieldTitle>
      <AgencyField />
      <AgencyStateField />
      {mode === "EDIT" ? (
        <AgencyLocationField />
      ) : (
        <MultiSelectAgencyLocationField />
      )}
      <StyledSignatureAccessContainer>
        <LevelField />
        <StyledToolTip
          title={SIGNATURE_ACCESS_TOOLTIP}
          placement="left"
          aria-label="lender-contact-info"
          arrow
          componentsProps={{
            tooltip: {
              sx: signatureToolTipStyle
              }
          }}
        >
          <StyledInfoIcon />
        </StyledToolTip>
      </StyledSignatureAccessContainer>
      {mode === "ADD" && (
        <StyledAddDefaultSignatureNoteText>
          {ADD_DEFAULT_SIGNATURE_NOTE}
        </StyledAddDefaultSignatureNoteText>
      )}
    </DefaultInfoWrapper>
  );
};

export default DefaultInfo;
